import { IdeaContentType } from "./types";
import type { DropdownOption } from "@/components/ui/OptionDropdown";

// Single source of truth for idea content-type labels. Content types carry no
// colors, so pickers render the plain-text OptionDropdown variant (TD-005).
export const IDEA_CONTENT_TYPE_LABELS: Record<IdeaContentType, string> = {
  POST: "Post",
  REEL: "Reel",
  CAROUSEL: "Carousel",
  STORY: "Story",
};

export const IDEA_CONTENT_TYPE_OPTIONS: DropdownOption<IdeaContentType>[] =
  (Object.entries(IDEA_CONTENT_TYPE_LABELS) as [IdeaContentType, string][]).map(
    ([value, label]) => ({ value, label })
  );
